export default __webpack_public_path__ + "static/media/1_Harvard Common App Essay.a78e818c.pdf";